import { createApp } from 'vue/dist/vue.esm-bundler';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faBars,
    faCheck, faTimes
} from '@fortawesome/free-solid-svg-icons';
import { faUserHardHat } from '@fortawesome/pro-solid-svg-icons';
// import { } from '@fortawesome/pro-light-svg-icons';
// import { } from '@fortawesome/pro-regular-svg-icons';
// import { } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
    faCheck, faTimes, faUserHardHat, faBars
);

createApp({
    data: () => ({
        navigationIsOpen: false,
        isMobile: false,
    }),
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    mounted() {
        // Select .header and set visibility to visible
        const headerElement = document.querySelector('.header');
        if (headerElement) {
            headerElement.style.visibility = 'visible';
        }
    },
    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            console.log("window.innerWidth", window.innerWidth);
            if (window.innerWidth > 860) {
                this.isMobile = false;
            } else {
                this.isMobile = true;
            }
        },
        closeMobileMenu() {
            this.navigationIsOpen = false;
            console.log("Close mobile navigation");
        },
        openMobileMenu() {
            this.navigationIsOpen = true;
            console.log("Open mobile navigation");
        },
    }
})
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount("#app");
